import { render, staticRenderFns } from "./personnelInspection.vue?vue&type=template&id=01a8fe06&scoped=true&"
import script from "./personnelInspection.vue?vue&type=script&lang=js&"
export * from "./personnelInspection.vue?vue&type=script&lang=js&"
import style0 from "./personnelInspection.vue?vue&type=style&index=0&id=01a8fe06&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a8fe06",
  null
  
)

export default component.exports